import { Box } from '@mui/joy';
import { Children } from 'react';

// Lays its children out in a single row: equal-width columns on mobile, each
// column shrunk to its content from sm up. Every child gets minWidth: 0 so long
// labels shrink instead of pushing the row wider than the screen.
export function ControlsGrid({ sx, children }) {
  const count = Children.count(children);

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: `repeat(${count}, 1fr)`, sm: `repeat(${count}, auto)` },
        gap: 1,
        width: { xs: '100%', sm: 'auto' },
        ...sx,
      }}
    >
      {Children.map(children, (child) => (
        <Box sx={{ minWidth: 0 }}>{child}</Box>
      ))}
    </Box>
  );
}
